export const ACCESS_LABELS = {
  editor: "Can edit",
  viewer: "Can view",
  ["no access"]: "No access",
};
